// @flow
import { createAction } from "redux-act";


import * as uiMenuActions from './uiMenu';
import * as uiSelectedLeagueActions from './uiSelectedLeague';
import * as leagueDraftActions from './leagueDraftUtils';
import * as teamDraftActions from './teamsDraft';
import * as playersActions from './players';
import * as checksumsActions from './checksums';
import * as positionsActions from './positions';
import * as roundsActions from './rounds';
import * as squadsActions from './squads';
import * as venuesActions from './venues';

export const rounds = roundsActions;
export const players = playersActions;
export const squads = squadsActions;
export const checksums = checksumsActions;
export const venues = venuesActions;

export const positions = positionsActions;

export const postSSO = createAction("Post SSO");
export const postSSOSuccess = createAction("Post SSO Success");
export const postSSOFailed = createAction("Post SSO Failed");

export const postUserLogin = createAction("Post User Login");
export const postUserLoginSuccess = createAction("Post User Login Success");
export const postUserLoginFailed = createAction("Post User Login Failed");

export const userLogout = createAction("User Logout");
export const userLogoutSuccess = createAction("User Logout Success");
export const userLogoutFailed = createAction("User Logout Failed");

export const fetchUser = createAction("Fetch User");
export const fetchUserSuccess = createAction("Fetch User Success");
export const fetchUserFailed = createAction("Fetch User Failed");

export const uiMenu = uiMenuActions;
export const uiSelectedLeague = uiSelectedLeagueActions;
export const leagueDraft = leagueDraftActions;
export const teamsDraft = teamDraftActions;

export const fetchNotificationsDraft = createAction("Fetch Notifications Draft");
export const fetchNotificationsDraftSuccess = createAction("Fetch Notifications Draft Success");
export const fetchNotificationsDraftFailed = createAction("Fetch Notifications Draft Faile");

export const setUserCoachBanner = createAction("Set User Coach Banner");

export const showGlobalErrorMessage = createAction('Error Message Show');
export const hideGlobalErrorModal = createAction('Error Message Hide');

export const fetchNotificationBar = createAction("Fetch Notification Bar");
export const fetchNotificationBarSuccess = createAction("Fetch Notification Bar Success");
export const hideNotificationBar = createAction("Hide Notification Bar");


// WEBPACK FOOTER //
// ./src/modules/actions/index.js